export default __webpack_public_path__ + "static/media/spinner.95f0ee82.gif";